export const MfaOption = {
  NotEnabled: 0,
  AllUsers: 1,
  AllAdmins: 2,
  SelectedUsers: 3,
  SelectedTeams: 4,
  SelectedRoles: 5,
};

export const MfaAuthenticatorApp = {
  Microsoft: 1,
  Google: 2,
  Salesforce: 3,
  LastPass: 4,
  Authy: 5,
  Other: 100,
};

export const ScriptNamespaceType = {
  Gac: 0,
  File: 1,
};
